import React, { useState } from "react";
import News from "blocks/news";
import useNewsFeed from "./useNewsFeed";
import styles from "./news-block.module.scss";

const PAGE_SIZE = 6;

const NewsBlock = ({ heading, copy, className, children }) => {
  return (
    <section className={`${styles.element} ${className}`}>
      <h3 className={styles.heading}>{heading}</h3>
      {copy ? <h4 className={styles.subheading}>{copy}</h4> : null}
      <div className={styles.list}>
        {children.map((update) => {
          if (update.typeHandle === "newsFeed") {
            return <NewsFeed key={update.id} />;
          }
          return update.news.length ? (
            update.news.map((item) => <News key={item.id} {...item} />)
          ) : (
            <News key={update.id} {...update} />
          );
        })}
      </div>
    </section>
  );
};

export default NewsBlock;

function NewsFeed() {
  const { data, loading, fetchMore } = useNewsFeed({ limit: PAGE_SIZE });
  const [loadingMore, setLoadingMore] = useState(false);
  const [hasMore, setHasMore] = useState(true);

  const items = (data && data.news) || [];

  const loadMore = () => {
    setLoadingMore(true);
    fetchMore({
      variables: { offset: items.length },
      updateQuery: (prev, { fetchMoreResult }) => {
        setLoadingMore(false);
        const more = fetchMoreResult && fetchMoreResult.news;
        if (!more || !more.length) {
          setHasMore(false);
          return prev;
        }
        if (more.length < PAGE_SIZE) setHasMore(false);
        return { ...prev, news: [...prev.news, ...more] };
      },
    });
  };

  if (loading && !items.length) return null;
  if (!items.length) return null;

  return (
    <>
      {items.map((item) => (
        <News key={item.id} {...item} />
      ))}
      {hasMore ? (
        <button
          type="button"
          className={styles.loadMore}
          onClick={loadMore}
          disabled={loadingMore}
        >
          {loadingMore ? "Loading…" : "Load More"}
        </button>
      ) : null}
    </>
  );
}
